import React from "react"
import styles from './SearchBox.scss'

const EmptySearch = ({children}) => {
	return (
		<div className={styles.noResults}>
			<img src={require('resources/images/icn-no-result.svg')}/>
			<p>{children}</p>
		</div>
	)
}
export default EmptySearch



// WEBPACK FOOTER //
// ./elements/EmptySearch.jsx